import React from 'react';
import { Store, ArrowRight, CloudSun, Database } from 'lucide-react';
import { OsCard } from '../theme';
import AgentAdviceRail from '../../components/AgentAdviceRail';

/* Restaurant owner home — their business at a glance, one tap into their OS. */

const relTime = (iso, isEs) => {
  if (!iso) return isEs ? 'sin sincronizar' : 'not synced yet';
  const m = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
  if (m < 60) return isEs ? `hace ${m} min` : `${m}m ago`;
  const h = Math.round(m / 60);
  return h < 24 ? (isEs ? `hace ${h} h` : `${h}h ago`) : (isEs ? `hace ${Math.round(h / 24)} d` : `${Math.round(h / 24)}d ago`);
};

export default function RestaurantHome({ me, home, isEs, enter, busy }) {
  const rests = (me?.workspaces || []).filter((w) => w.type === 'restaurant');
  const extra = home?.restaurants || {};
  const weather = me?.weather;
  return (
    <div data-testid="restaurant-home">
      {weather && weather.temp != null && (
        <OsCard className="mt-6 p-4 flex items-center gap-3" data-testid="restaurant-weather">
          <CloudSun className="w-5 h-5" style={{ color: 'var(--os-accent)' }} />
          <p className="text-[13px]" style={{ color: 'var(--os-ink-soft)' }}>
            {weather.city && <b style={{ color: 'var(--os-ink)' }}>{weather.city} · </b>}
            <span className="whitespace-nowrap">{Math.round(weather.temp * 9 / 5 + 32)}°F · {Math.round(weather.temp)}°C</span>
            {weather.days?.[1] && <> · {isEs ? 'mañana' : 'tmrw'} {Math.round(weather.days[1].max * 9 / 5 + 32)}°F</>}
            {' — '}{isEs ? 'planifica tu servicio de hoy.' : 'plan today\u2019s service.'}
          </p>
        </OsCard>
      )}
      <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-4">
        {rests.map((w, i) => {
          const ex = extra[w.id] || {};
          const imp = ex.last_import;
          return (
            <OsCard key={w.id} className="p-5 os3-rise" style={{ animationDelay: `${i * 60}ms`, borderTop: `3px solid ${w.color}` }}
              data-testid={`rest-card-${w.id.replace(':', '-')}`}>
              <div className="flex items-center gap-3">
                {w.logo ? <img src={w.logo} alt="" className="h-10 w-auto max-w-[110px] object-contain rounded-lg" />
                  : <span className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: `${w.color}18` }}><Store className="w-5 h-5" style={{ color: w.color }} /></span>}
                <div className="min-w-0 flex-1">
                  <p className="text-[16px] font-bold truncate" style={{ color: 'var(--os-ink)' }}>{w.founding && '⭐ '}{w.name}</p>
                  <p className="text-[11.5px] truncate" style={{ color: 'var(--os-ink-faint)' }}>{w.os_id}{w.city ? ` · ${w.city}` : ''}</p>
                </div>
              </div>
              <div className="mt-4 grid grid-cols-2 gap-2 text-[12px]" style={{ color: 'var(--os-ink-soft)' }}>
                <p className="flex items-center gap-1.5"><Database className="w-3.5 h-3.5" style={{ color: 'var(--os-accent)' }} />
                  {isEs ? 'Último sync' : 'Last sync'}: <b style={{ color: 'var(--os-ink)' }}>{relTime(w.last_sync, isEs)}</b></p>
                {imp && <p>{isEs ? 'Última carga' : 'Last import'}: <b style={{ color: 'var(--os-ink)' }}>{imp.rows || 0} {isEs ? 'filas' : 'rows'}</b></p>}
              </div>
              <button onClick={() => enter(w)} disabled={busy === w.id} data-testid={`rest-enter-${w.id.replace(':', '-')}`}
                className="mt-4 w-full inline-flex items-center justify-center gap-2 rounded-full py-2.5 text-[13px] font-bold text-white transition-all hover:opacity-90 disabled:opacity-50"
                style={{ background: w.color }}>
                {isEs ? 'Entrar a mi Restaurant OS' : 'Enter my Restaurant OS'} <ArrowRight className="w-4 h-4" />
              </button>
            </OsCard>
          );
        })}
      </div>
      <AgentAdviceRail audience="client" isEs={isEs} className="mt-5"
        onCardClick={() => { const w = rests[0]; if (w) enter(w); }} />
    </div>
  );
}
